<template>
  <div class="d-flex justify-content-between align-items-center">
    <div
      class="toggle-bar"
      :style="[bool ? 'background-color:#D1F9ED' : 'background-color: #CCCCCD', disabled ? 'pointer-events: none;' : '']"
      @click="handleToggle"
    >
      <div
        class="toggle-dot shadow"
        :class="{
          active: bool,
        }"
        :style="bool ? 'background-color: #30CB9D' : 'background-color: #FFF'"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      bool: false,
    };
  },
  watch: {
    value(val) {
      this.bool = val;
    },
  },
  mounted() {
    this.bool = this.value;
  },
  methods: {
    handleToggle() {
      this.$emit("onChange", !this.bool);
    },
  },
};
</script>

<style lang="scss" scoped>
.toggle-bar {
  min-width: 34px;
  min-height: 18px;
  display: flex;
  align-items: center;
  transition: all 0.3s ease-in-out;
  border-radius: 9999px;
  cursor: pointer;
}

.toggle-dot {
  width: 20px;
  height: 20px;
  transition: all 0.3s ease-in-out;
  border-radius: 9999px;
  transform: translateX(0);

  &.active {
    transform: translateX(14px);
  }
}
</style>
